import script from "./UserPermissionMixin.vue?vue&type=script&lang=js"
export * from "./UserPermissionMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__